import{Observable as r}from"../Observable.js";import{noop as o}from"../util/noop.js";var t=new r(o);function e(){return t}export{t as NEVER,e as never};
